export const BDT = (amount) => {
  const num = Number(amount || 0);
  return "৳ " + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Dhaka",
    });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Dhaka",
    });
  } catch {
    return iso;
  }
};

export const todayDhaka = () => {
  const d = new Date();
  const utc = d.getTime() + d.getTimezoneOffset() * 60000;
  const dhaka = new Date(utc + 6 * 3600000);
  return dhaka.toISOString().slice(0, 10);
};
